import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSpacebar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="spacebar" maskId="round-filled-radius-0-stroke-1.5-IconSpacebar"><path d="M2 13.75C2 13.3358 2.33579 13 2.75 13C3.16421 13 3.5 13.3358 3.5 13.75V18.5H20.5V13.75C20.5 13.3358 20.8358 13 21.25 13C21.6642 13 22 13.3358 22 13.75V19.25C22 19.6642 21.6642 20 21.25 20H2.75C2.33579 20 2 19.6642 2 19.25V13.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSpacebar;
